const hasOwnProperty = Object.prototype.hasOwnProperty;

// I'm adding the `keyof O` only to get helpful autocomplete. If it turns out to
// be too restrictive I might remove it in future.
export function hasOwn<O extends Record<string, unknown>>(
  object: O,
  key: keyof O,
): boolean {
  return hasOwnProperty.call(object, key);
}
